/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export interface PaginationTileProps {
  disabled?: boolean;
  onClick?: () => void;
  sides?: "left" | "right" | "both" | "none";
  active?: boolean;
  hideOnMobile?: boolean
}

const PaginationTile: React.FC<React.PropsWithChildren<PaginationTileProps>> = ({
  children,
  disabled,
  active,
  onClick,
  sides = "none",
  hideOnMobile,
}) => (
  <div
    onClick={() => !disabled && onClick?.()}
    className={`
    ${hideOnMobile ? "hidden md:inline-flex" : "inline-flex"}
    justify-center items-center select-none
    ${sides === "left" ? "rounded-l-md" : ""}
    ${sides === "right" ? "rounded-r-md" : ""}
    ${sides === "both" ? "rounded-md" : ""}
    typography-small-base p-2 w-9 h-9
    ${!disabled && onClick ? "hover:bg-bg-components-hover active:bg-bg-components-pressed cursor-pointer" : ""}
    ${!disabled ? "text-icon-bg-subtle " : "bg-bg-disabled text-icon-disabled"}
    ${active ? "bg-bg-subtle text-icon-active" : ""}
  `}
  >
    {children}
  </div>
);

export default PaginationTile;
